import * as React from 'react';
import {
  Pressable,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

import shouldUpdateEntity from '../../shared/enhanced/shouldUpdateEntity';
import ArrowForwardIcon from '../../shared/icons/ArrowForwardIcon';

import {size} from '../../../styles/variables';

import ManualCategory from '../../../../domain/entities/writer/ManualCategory';

interface Props {
  manualCategory: ManualCategory;
  onSelectManualCategory: (manualCategory: ManualCategory) => void;
}

export default class ManualListItem extends React.Component<Props> {
  public shouldComponentUpdate(nextProps: Readonly<Props>): boolean {
    return shouldUpdateEntity(
      {entity: this.props.manualCategory},
      {entity: nextProps.manualCategory},
    );
  }

  public render(): React.ReactNode {
    const {manualCategory} = this.props;
    return (
      <Pressable onPress={this.handlePress}>
        <View style={styles.container}>
          <View style={styles.containerInner}>
            <View style={styles.title}>
              <Text style={styles.titleText}>{manualCategory.name}</Text>
            </View>
            <View>
              <ArrowForwardIcon />
            </View>
          </View>
        </View>
      </Pressable>
    );
  }

  private handlePress = () => {
    const {manualCategory, onSelectManualCategory} = this.props;
    onSelectManualCategory(manualCategory);
  };
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    justifyContent: 'center',
    minHeight: size.minTapHeight,
  } as ViewStyle,
  containerInner: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
  } as ViewStyle,
  title: {
    flex: 1,
    marginHorizontal: 5,
  } as ViewStyle,
  titleText: {
    color: '#222222',
    fontSize: 13,
    fontWeight: 'bold',
  } as TextStyle,
});
